/**
 * Row selection for `DataTable`, as plain functions (ops insights 08: the Jobs list's "Set
 * service type" is the table's first selecting consumer). No React here, so every rule is
 * tested by calling it, and the table's boxes (`RowSelectBox`, `PageSelectBox`) only wire them.
 *
 * The selection is a set of row KEYS, owned by the page, like the Schedule page's: the table
 * draws the boxes and reports the next set; the page decides what the set is for, and which
 * view it belongs to.
 */

/** The set with `key` ticked if it was not, and unticked if it was. Never mutates `ticked`. */
export function toggleRow(ticked: ReadonlySet<string>, key: string): ReadonlySet<string> {
  const next = new Set(ticked);
  if (!next.delete(key)) next.add(key);
  return next;
}

/** How much of this page is ticked: the header box shows `all` ticked, `some` as mixed. */
export function pageTick(
  ticked: ReadonlySet<string>,
  pageKeys: readonly string[],
): 'all' | 'some' | 'none' {
  const count = pageKeys.filter((key) => ticked.has(key)).length;
  if (count === 0) return 'none';
  return count === pageKeys.length ? 'all' : 'some';
}

/**
 * The header box: a page that is all ticked is unticked, and any other page is ticked whole.
 * Keys that are not on this page are left as they were.
 */
export function togglePage(
  ticked: ReadonlySet<string>,
  pageKeys: readonly string[],
): ReadonlySet<string> {
  const next = new Set(ticked);
  if (pageTick(ticked, pageKeys) === 'all') for (const key of pageKeys) next.delete(key);
  else for (const key of pageKeys) next.add(key);
  return next;
}
